<script lang="ts">
    /* This button allows employee submission to be triggered globally, wherever
     the "Speichern" button is pressed.
     */

    import {getContext, onMount} from "svelte";
    import type {Writable} from "svelte/store";

    export let loading = false;
    let button_to_submit: HTMLButtonElement;

    let trigger_submits: Writable<Set<HTMLButtonElement>> = getContext("trigger_submits");

    onMount(() => {
        $trigger_submits.add(button_to_submit)
    });
</script>
<button hidden bind:this={button_to_submit} disabled={loading}/>
